import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { CREATE_DMX_CONTROLLER } from './actionTypes';
import { createDmxControllerSuccessful, createDmxControllerFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* createController({ payload: { controller } }) {
  try {
    const response = yield call(dmxAPI.createController, controller.token, controller);
    if (response.message) {
      yield put(createDmxControllerSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(createDmxControllerFailed(error));
  }
}

export function* watchCreateDmxController() {
  yield takeEvery(CREATE_DMX_CONTROLLER, createController);
}

function* createDmxControllerSaga() {
  yield all([fork(watchCreateDmxController)]);
}

export default createDmxControllerSaga;
